/** Recharts animation + palette for Naturals HQ / partner analytics. */
export const CHART_ANIMATION = {
  isAnimationActive: true,
  animationDuration: 900,
  animationEasing: "ease-out",
};

export const CHART_ANIMATION_SLOW = {
  ...CHART_ANIMATION,
  animationDuration: 1200,
};

export const CHART_PALETTE = [
  "#22d3ee",
  "#a78bfa",
  "#f472b6",
  "#34d399",
  "#fbbf24",
  "#60a5fa",
  "#fb7185",
  "#4ade80",
];

export const CHART_SERIES = {
  queued: "#94a3b8",
  in_service: "#f97316",
  completed: "#dc2626",
  cancelled: "#eab308",
  sales: "#0d9488",
  accessed: "#94a3b8",
  primary: "#dc2626",
  secondary: "#22d3ee",
  accent: "#a78bfa",
};

export const chartAxisTick = { fill: "var(--chart-axis, #64748b)", fontSize: 11 };

export const chartGridStroke = "var(--chart-grid, #e2e8f0)";

export function barSeriesProps(color, delay = 0) {
  return {
    fill: color,
    radius: [4, 4, 0, 0],
    ...CHART_ANIMATION,
    animationBegin: delay,
  };
}

export function horizontalBarProps(color) {
  return {
    fill: color,
    radius: [0, 4, 4, 0],
    ...CHART_ANIMATION,
  };
}

export function lineSeriesProps(color, delay = 0) {
  return {
    type: "monotone",
    stroke: color,
    strokeWidth: 2.5,
    dot: { r: 3, strokeWidth: 0, fill: color },
    activeDot: { r: 5 },
    ...CHART_ANIMATION,
    animationBegin: delay,
  };
}

export function areaSeriesProps(color, delay = 0) {
  return {
    type: "monotone",
    stroke: color,
    fill: color,
    fillOpacity: 0.28,
    strokeWidth: 2,
    ...CHART_ANIMATION,
    animationBegin: delay,
  };
}
